

import React from 'react';
import ScreenClassProvider, { ScreenClassContext, NO_PROVIDER_FLAG } from '../ScreenClassProvider';




const ScreenClassResolver = ({ children }) =>
<ScreenClassContext.Consumer>
    {(screenClassCheck) => {
    if (screenClassCheck === NO_PROVIDER_FLAG) {
      return (
        <ScreenClassProvider>
            <ScreenClassContext.Consumer>
              {(screenClassResolved) => children(screenClassResolved)}
            </ScreenClassContext.Consumer>
          </ScreenClassProvider>);

    }
    return children(screenClassCheck);
  }}
  </ScreenClassContext.Consumer>;


export default ScreenClassResolver;